import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { EngineFieldPatchPayload } from '@rossum/api-client/engineFields';
import { api } from '../../../lib/apiClient';
import { engineFieldKeys, mutationKey } from '../keys';
import { useToastMessage } from './useToastMessage';

export const patchEngineFieldKey = (id: ID) =>
  mutationKey(['patch_engine_field', id] as const);

export const usePatchEngineField = (id: ID) => {
  const queryClient = useQueryClient();
  const { showToastMessage } = useToastMessage();

  return useMutation({
    mutationKey: patchEngineFieldKey(id),
    mutationFn: (payload: EngineFieldPatchPayload) =>
      api.request(endpoints.engineFields.patch(id, payload)),
    onSuccess: result => {
      showToastMessage('engineFieldUpdated');
      queryClient.setQueryData(engineFieldKeys.detail(id), result);
    },
  });
};
